import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import TransomConfigurator from './../TransomConfigurator';
import RadioGroup from './../RadioGroup';
import { withTranslation, Trans } from 'react-i18next';
import { cameraView09MastSailsBoomImageOptions } from './views/CameraView09MastSailsBoom'

class X49Mast extends Component {
    constructor(props) {
        super(props);
        this.handleMastAndBoomChange = this.handleMastAndBoomChange.bind(this);
    }

    handleMastAndBoomChange(newValue) {
        let configuration = this.props.configuration;
        configuration.MastAndBoom = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = cameraView09MastSailsBoomImageOptions;

        let image = (
            <TransomConfigurator colorMultiplier={0.6} name={this.props.transom.Name} port={this.props.transom.Port} transomSize={{ width: 2895, height: 780 }} transform={
                [
                    0.098089, 0.020989, 0, 0.00005,
                    0.015397, 0.096827, 0, 0.00001,
                    0, 0, 1, 0,
                    641, 384, 0, 1
                ]}>
                <ConfiguratorImage boat="X4_9" configuration={this.props.configuration} options={imageOptions} />
            </TransomConfigurator>
        );

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>
                    <h1><Trans defaults='Mast & boom' /></h1>

                    <h2><Trans defaults='Finish' /></h2>

                    <RadioGroup options={this.props.mastAndBoomOptions} value={this.props.configuration.MastAndBoom} onChange={this.handleMastAndBoomChange} />

                    <p><Trans defaults='Info text: Optional features contact dealer' /></p>

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X49Mast);


// WEBPACK FOOTER //
// ./src/X49/X49Mast.js